import { Field, Form, HousingAlert, Sender } from "@garantidos/components"

import If from "@mobi/components/If"
import Stepper from "@mobi/ds/components/Stepper"

import Loader from "../../../../../../components/Loader"

import useName from "./hooks"

import "../../style.scss"

const NameOneClick = () => {
  const {
    isLoadingPage,
    onSubmitCallback,
    handlePrevStep,
    fields,
    form,
    errorMessage,
    setErrorMessage,
    isLoading,
    hasCpfFromHero
  } = useName()
  const { name } = fields
  const { isValid } = form

  return (
    <If
      condition={isLoadingPage}
      renderIf={<Loader hideLogo />}
      renderElse={
        <div className="softleadSimulationOneClick">
          <div className="softleadSimulationOneClick__formWrapper">
            <HousingAlert
              message={errorMessage}
              setMessage={setErrorMessage}
              type="error"
            />
            <h1 className="softleadSimulationOneClick__title">
              como você se chama?
            </h1>
            <Form onSubmit={onSubmitCallback} form={form}>
              <Field
                autoComplete="off"
                field={name}
                form={form}
                data-testid={name.name}
                disabled={isLoading}
              />
              <Sender
                showPrev={hasCpfFromHero ? false : true}
                onPrev={handlePrevStep}
                data_testid="submit"
                isNextDisabled={!isValid}
                nextLabel="avançar"
                isLoading={isLoading}
              />
            </Form>
          </div>
        </div>
      }
    />
  )
}

export default NameOneClick
